module.exports = __webpack_public_path__ + "img/icon-BusinessServiceCenter.57bde1ce.png";